import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const UserMyMedicalReport = () => {
	const [file1, setFile1] = useState(null);
	const [file2, setFile2] = useState(null);

	const handleFileChange = (event, setFile) => {
		setFile(event.target.files[0]);
	};

	const handleFileUploadClick = (index) => {
		document.getElementById(`file-input-${index}`).click();
	};

	const handleCancelClick = (setFile) => {
		setFile(null);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		// Handle form submission
	};
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										My Medical Reports
									</h5>
								</div>
								<form onSubmit={handleSubmit}>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group d-flex-wrapper-upload col-lg-12">
													<div
														className="pdf-icon"
														onClick={() => handleFileUploadClick(1)}
													>
														<i className="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={(event) =>
															handleFileChange(event, setFile1)
														}
														className="form-control"
														id="file-input-1"
														style={{ display: "none" }}
													/>
													<div
														className="icon-input"
														onClick={() => handleCancelClick(setFile1)}
													>
														<i className="fa-solid fa-xmark"></i>
													</div>
													<span className="medical-placeholder">
														{file1 ? file1.name : "Medical report.pdf"}
													</span>
												</div>
											</div>
										</div>
									</div>
									<div className="row input-file-wrapper">
										<div className="form-group col-lg-12">
											<div className="position-relative">
												<div className="form-group d-flex-wrapper-upload col-lg-12">
													<div
														className="pdf-icon"
														onClick={() => handleFileUploadClick(2)}
													>
														<i className="fa-solid fa-file-pdf"></i>
													</div>
													<input
														type="file"
														accept="application/pdf"
														onChange={(event) =>
															handleFileChange(event, setFile2)
														}
														className="form-control"
														id="file-input-2"
														style={{ display: "none" }}
													/>
													<div
														className="icon-input"
														onClick={() => handleCancelClick(setFile2)}
													>
														<i className="fa-solid fa-xmark"></i>
													</div>
													<span className="medical-placeholder">
														{file2 ? file2.name : "Medical report.pdf"}
													</span>
												</div>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-lg-12">
											<h4 className="text-center extra-color-10 level-7 primary-medium-font">
												Recently Uploaded Report
											</h4>
										</div>
									</div>
									<Link
										className="btn wrapper-btn-main mb-5 log-in mt-3 level-7 primary-regular-font text-decoration-none w-100"
										to=""
									>
										<span className="bg-wrapper w-100">
											<span className="pe-2">
												<i className="fa-solid fa-upload"></i>
											</span>
											Upload Report
										</span>
									</Link>
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserMyMedicalReport;
